
import { defineComponent } from 'vue'

export default defineComponent({
	props: {
		time: {
			type: String,
			default: ''
		},

		theme: {
			type: String,
			default: ''
		}
	}
})
